import { render, staticRenderFns } from "./InGoingCall.vue?vue&type=template&id=5b9bffb9"
import script from "./InGoingCall.vue?vue&type=script&lang=ts"
export * from "./InGoingCall.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports